import { registerComponent } from '@gig/magic-common';
import ViewLimitsComponent from './view-limits.vue.js';

var ViewLimits = registerComponent(ViewLimitsComponent);

export { ViewLimits };
